
// @ts-nocheck





import { i18nText } from '@/locales';


import {FormModel} from "ant-design-vue/types/form-model/form";
import {Component} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {ClientsStore} from "@/store/modules/Clients";
import {LoyaltyCertTypeStore} from "@/store/modules/Loyalty/Cert/LoyaltyCertType";
import LoyaltyCertAddComponent from "@/UI/components/forms/loyalty/loyaltyCert/loyaltyCert/LoyaltyCertAddComponent.vue";
import LoyaltyCertUpdateComponent
  from "@/UI/components/forms/loyalty/loyaltyCert/loyaltyCert/LoyaltyCertUpdateComponent.vue";
import {LoyaltyCertStore} from "@/store/modules/Loyalty/Cert/LoyaltyCert";
import {ILoyaltyCertListItem} from "@/entity/loyalty/loyaltyCert/loyaltyCert/loyaltyCert.types";
import {mixins} from "vue-class-component";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import AppFilterTable from "@/UI/components/extFilter/AppFilterTable.vue";
import {Button, Menu, List, Table, Select, Input, Tabs, Modal} from "ant-design-vue";
import {LoyaltyCertFormData, FormRules} from "@/form/loyalty/loyaltyCert/LoyaltyCert";
import {showNotification} from "@/UI/lib/messages";
import {HandleScrollStore, HandleScrollStorewithParam, SearchinStore} from "@/UI/Decorators/decorator";
import {ProxyTableData} from "@/UI/components/Helpers/ProxyTableData";
import {TableColumns} from "@/UI/pages/loyalty/lib/table"
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";
import {SalonsRepository} from "@/repository/salons/SalonsRepository.ts";
import {getStudioId} from "@/UI/lib/state";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import {ClientLoyaltyTableMix} from "@/UI/mixins/Loaylty/ClientLoyaltyTableMix";
import {LoyaltyCertMix} from "@/UI/mixins/Loaylty/LoyaltyCertMix";


@Component({
  components: {
    PageTitle,
    LoyaltyCertAddComponent,
    LoyaltyCertUpdateComponent,
    AppFilterTable,
    BaseDataForm,
    ClientLoyaltyTableMix,
    LoyaltyCertMix,

    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-input": Input,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-modal": Modal,
    SortComponent
  },
})

export default class LoyaltyCert extends mixins(
  ProxyGetData,
  ProxyTableData,
  TableColumns
) {
  showCertificateModal = false;
  newform = new LoyaltyCertFormData();
  newRules = FormRules;
  modalTitle = "";
  modalMode = 0;
  counterparty: ILoyaltyCertListItem | null = null;
  searchText = "";
  searchedColumn = "";

  cancelRemove(): void {
    //this.showUpdateModal = false;
  }

  @SearchinStore
  hSearch(source: string, value: string, useStudio: boolean): void {
  }

  @HandleScrollStore
  hScroll(event: any, value: string): void {
  }

  @HandleScrollStorewithParam
  hScrollParam(event: any, value: string, value2: string, useStudio: boolean): void {
  }

  handleSearchTypes(value: string): void {
    this.hSearch("loyaltyCertType", value, true);
  }

  handleSearchCashboxes(value: string): void {
    this.hSearch("cashbox", value, true);
  }

  handleScrollTypes(event: any): void {
    this.hScrollParam(event, "loyaltyCertType", "loyaltyCertTypes", true);
  }

  handleSearchClients(value: string): void {
    this.hSearch("clients", value, true);
  }

  handleScrollClients(event: any): void {
    this.hScrollParam(event, "clients", "clients", true);
  }

  onCertificateTypeChange(value: number): void {
    if (this.certificateTypes && this.certificateTypes.data) {
      const currentType = this.certificateTypes.data.filter((item: Record<string, any>) => {
        return item.id == value
      })[0];
      this.newform.cashbox_sum = Number(currentType?.balance || 0);
    }
  }

  clientLink(record: Record<string, any>): any {

    if (record.client) {
      return {name: 'ClientDetailCommon', id: record.client.id, params: {id: record.client.id}}
    }
    return {}
  }

  typeLink(record: Record<string, any>): any {
    return {
      name: 'LoyaltyCertTypeGet',
      query: {readonly: 1},
      params: {Studio: getStudioId(this), id: record.type_id}
    }
  }

  updateData(record: any): void {
    this.modalMode = 1;
    this.newform = new LoyaltyCertFormData();
    this.newform["id"] = record["id"];
    // this.newform["client_id"] = record["client_id"];
    this.newform["client_id"] = record["client_name"];
    // this.newform["type_id"] = record["type_id"];
    this.newform["type_id"] = record.type["name"];
    this.newform["cashbox_id"] = record["cashbox_id"];
    this.newform["salon_id"] = record["salon_id"];
    this.newform["code"] = record["code"];
    this.showCertificateModal = true;
  }

  saving = false;

  addCert(): void {
    this.modalTitle = i18nText("Добавить сертификат");
    this.modalMode = 0;
    this.newform = new LoyaltyCertFormData();
    this.newform.salon_id = getStudioId(this);
    this.showCertificateModal = true;
  }

  handleCancel(): void {
    this.showCertificateModal = false;
  }

  async onUpdate(): Promise<void> {
    (this.$refs.certForm as FormModel).validate(async (valid) => {
      if (valid) {
        this.saving = true;
        try {
          //TODO::Получаем salon_id
          this.newform.salon_id = this.$store.state["salon_id"];
          LoyaltyCertStore.update(this.newform).then((response) => {
            //TODO:: Reactive
            showNotification(i18nText("Сертификат обновлен"), response);
          });
        } catch (e) {
          console.log("Cert Updated");
          console.log(e.message);
        } finally {
          await this.createProxy();
          this.showCertificateModal = false;
        }
      } else {
        return false;
      }
    });
  }

  async removeCert(): Promise<void> {
    const remove_id = this.newform["id"];
    try {
      await LoyaltyCertStore.delete(Number(remove_id)).then((response) => {
        this.$notification.open({
          message: i18nText("Удаление сертификата"),
          description: response["response"],
          duration: 0,
        });
      });
    } catch (e) {
      console.log(i18nText("Ошибка удаления сертификата"));
    } finally {
      this.showCertificateModal = false;
      await this.createProxy();
    }
  }

  async onSubmit(): Promise<void> {
    if (this.saving) return;
    (this.$refs.certForm as FormModel).validate(async (valid) => {
      if (valid) {
        this.saving = true;
        try {
          //TODO::Получаем salon_id
          this.newform.salon_id = getStudioId(this);
          const response = await LoyaltyCertStore.create(this.newform);

          if (response.status) {
            showNotification(i18nText("Сертификат добавлен"), response);
            await this.createProxy();
            this.showCertificateModal = false;
          } else {
            this.$message.error(response.response);
          }
        } catch (e) {
          this.$message.error(e.response?.data?.errors ? Object.values(e.response.data.errors).flat().join(' ') : e.response?.data?.message || e.message);
        } finally { this.saving = false; }
      } else {
        return false;
      }
    });
  }

  async created(): Promise<void> {
    this.tableLoad = false;
    this.formReady = false;

    //this.cashboxes = await this.fetchCashboxes();
    //await LoyaltyCertStore.fetchAll({ limit: this.AppPageParams.pageSize });
    try {
      this.proxyFilter = {
        salon_id: getStudioId(this)
      }
      appPaginationStore.setCurrent(1)
      await this.fetchCashboxes();
      await this.createProxy();
      await LoyaltyCertTypeStore.fetchAll({
        limit: -1,
        filter: {salon_id: getStudioId(this)},
      });
      //TODO::Добавить к клиентам salon_id
      await ClientsStore.fetchAll({limit: this.AppPageParams.pageSize, filter: {salon_id: getStudioId(this)}});
      // this.certificate.data


      // ----- adding currency string (Starting line.) -----
      // ----- currencyIdOfThisStudio (Starting line.) -----
      let currencyIdOfThisStudio;
      let currencyOfThisStudioString;

      let response = await (new SalonsRepository).fetchAll({limit: -1});
      let thisStudioId = getStudioId(this);
      let thisStudio = response.data.filter(studio => {
        return thisStudioId == studio.id;
      })[0];
      currencyIdOfThisStudio = thisStudio.currency_id;
      // ----- decypher currency id (Starting line.) -----
      if (currencyIdOfThisStudio == 1) {
        currencyOfThisStudioString = 'RUB';
      }
      if (currencyIdOfThisStudio == 2) {
        currencyOfThisStudioString = 'USD';
      }
      if (currencyIdOfThisStudio == 3) {
        currencyOfThisStudioString = 'EUR';
      }
      // ----- decypher currency id (Ending line.) -----
      // ----- currencyIdOfThisStudio (Ending line.) -----


      this.certificate.data.forEach((element) => {
        if (!element.balance.toString().match(new RegExp(' ' + currencyOfThisStudioString + '$', 'gmi'))) {
          element.balance = (element.balance.toString().replace(/\..+$/gmi, '') + ' ' + currencyOfThisStudioString)
        }
        if (!element.start_balance.toString().match(new RegExp(' ' + currencyOfThisStudioString + '$', 'gmi'))) {
          element.start_balance = (element.start_balance.toString().replace(/\..+$/gmi, '') + ' ' + currencyOfThisStudioString)
        }
      });
      // ----- adding currency string (Ending line.) -----


    } catch (e) {
      console.log("Cert load data error ");
    } finally {
      this.formReady = true;
      this.tableLoad = true;
    }
  }

  get cashboxes(): ICashboxListItem[] | undefined {
    return CashboxStore.items?.data;
  }

  async fetchCashboxes(): Promise<ICashboxListItem[]> {
    await CashboxStore.fetchAll({limit: 20, filter: {salon_id: getStudioId(this)}});

    if (CashboxStore.items) {
      return CashboxStore.items.data;
    } else {
      return [];
    }
  }

  get certificateTypes(): any {
    return LoyaltyCertTypeStore.loyaltyCertTypes
  }

  get client(): any {
    return ClientsStore.clients
  }

  get certificate(): any {
    return LoyaltyCertStore.loyaltyCerts
  }

  async setFilter({by, sort}): void {
    await this.sortedData(by, {dataIndex: sort.dataIndex})
  }
}
